function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M664.4,745.014l-26.134,8.417,14.753,4.708,14.14-4.546Z",
  transform: "translate(-635.876 -745.014)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M614.852,835.269v9.452l14.128,4.513,14.75-4.74Z",
  transform: "translate(-614.852 -826.062)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M646.133,933.358l-31.281,10.074,2.752,8.56,28.529-9.171Z",
  transform: "translate(-614.852 -914.145)",
  fill: "#fff"
}));

function SvgStreamyMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.281,
    height: 37.847,
    viewBox: "0 0 31.281 37.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamyMark);
export default __webpack_public_path__ + "static/media/streamy-mark.26850c96.svg";
export { ForwardRef as ReactComponent };